<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1.18506L5.85858 6.04364C5.93668 6.12174 5.93668 6.24838 5.85858 6.32648L1 11.1851" stroke="#0F9129" stroke-width="1.6" stroke-linecap="round"/>
</svg>
